import { cn } from "@/components/podkit/lib/cn";
import { type FC } from "react";

type GroupAvatarProps = {
    groupName: string;
    size?: "xs" | "sm" | "md" | "lg";
    className?: string;
};

const sizeClasses = {
    xs: "size-6 text-xs",
    sm: "size-8 text-sm",
    md: "size-10 text-sm",
    lg: "size-12 text-base",
};

// Generate consistent color based on group name
const getGroupColor = (name: string): string => {
    const colors = [
        "bg-blue-500",
        "bg-green-500",
        "bg-purple-500",
        "bg-orange-500",
        "bg-pink-500",
        "bg-indigo-500",
        "bg-teal-500",
        "bg-red-500",
        "bg-yellow-500",
        "bg-cyan-500",
    ];

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = ((hash << 5) - hash) + name.charCodeAt(i);
        hash = hash & hash; // Convert to 32-bit integer
    }

    return colors[Math.abs(hash) % colors.length];
};

// Extract initials from group name
const getInitials = (name: string): string => {
    return name
        .split(/\s+/)
        .map(word => word[0])
        .join("")
        .toUpperCase()
        .substring(0, 2);
};

export const GroupAvatar: FC<GroupAvatarProps> = ({
    groupName,
    size = "md",
    className
}) => {
    const initials = getInitials(groupName);
    const colorClass = getGroupColor(groupName);

    return (
        <div
            className={cn(
                "flex items-center justify-center text-white font-medium rounded-md",
                sizeClasses[size],
                colorClass,
                className
            )}
            title={groupName}
        >
            {initials}
        </div>
    );
};
